import { WorkCalendar } from "./calendar";
import type { Project, Schedule } from "./types";

export interface ScheduleImpact {
  /** working days; positive = later */
  finishDeltaDays: number;
  previousFinish: string;
  finish: string;
  changedTaskIds: string[];
  /** tasks that became critical */
  newlyCritical: string[];
  /** tasks that stopped being critical */
  noLongerCritical: string[];
  newNegativeFloat: string[];
  criticalPathChanged: boolean;
  label: string;
}

export function diffSchedules(project: Project, before: Schedule, after: Schedule, label: string, calendar?: WorkCalendar): ScheduleImpact {
  const cal = calendar ?? new WorkCalendar(project.calendar);
  const finishDeltaDays = cal.ordinalBeforeISO(after.projectFinish) - cal.ordinalBeforeISO(before.projectFinish);
  const changed: string[] = [];
  const newlyCritical: string[] = [];
  const noLongerCritical: string[] = [];
  const newNegativeFloat: string[] = [];
  for (const [id, a] of after.tasks) {
    const b = before.tasks.get(id);
    if (!b) {
      changed.push(id);
      continue;
    }
    if (a.start !== b.start || a.finish !== b.finish) changed.push(id);
    if (a.critical && !b.critical && !a.isSummary) newlyCritical.push(id);
    if (!a.critical && b.critical && !a.isSummary) noLongerCritical.push(id);
    if (a.totalFloat < 0 && b.totalFloat >= 0) newNegativeFloat.push(id);
  }
  const cpA = after.criticalPath.join("|");
  const cpB = before.criticalPath.join("|");
  return {
    finishDeltaDays,
    previousFinish: before.projectFinish,
    finish: after.projectFinish,
    changedTaskIds: changed,
    newlyCritical,
    noLongerCritical,
    newNegativeFloat,
    criticalPathChanged: cpA !== cpB,
    label,
  };
}
